import React from "react";
import { PrimaryButton, SecondaryButton } from "../Button";
import { useModal } from "../Modal";
import { DialogTitle, styled } from "@mui/material";
import { DialogModalProps } from "./types";

const DialogModal: React.FC<DialogModalProps> = ({
  title,
  message,
  onConfirm,
  confirmButtonLabel,
  cancelButtonLabel,
  className,
}) => {
  const { closeModal } = useModal();
  return (
    <StyledDialogModal className={className}>
      {title && <StyledDialogTitle>{title}</StyledDialogTitle>}
      <StyledDialogBody>{message}</StyledDialogBody>
      <SecondaryButton onClick={closeModal} className="dialog-modal-button">
        {cancelButtonLabel}
      </SecondaryButton>
      <PrimaryButton
        className="dialog-modal-button"
        onClick={() => {
          onConfirm();
          closeModal();
        }}
      >
        {confirmButtonLabel}
      </PrimaryButton>
    </StyledDialogModal>
  );
};

export default DialogModal;
const StyledDialogTitle = styled(DialogTitle)(() => ({
  fontFamily: "'Nunito',sans-serif",
  padding: 0,
  textAlign: "left",
  width: "100%",
  fontSize: "16px",
  fontWeight: 700,
}));
const StyledDialogBody = styled("span")(() => ({
  width: "100%",
  marginBottom: "0.5rem",
  fontSize: "12px",
}));

const StyledDialogModal = styled("div")(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "1rem",
  maxWidth: "520px",
  justifyContent: "flex-end",
}));
